export default __webpack_public_path__ + "static/media/coins_dark.be1ad4e9.png";